import React, {useState} from 'react';
import {Button, Dropdown} from 'antd';
import {DownOutlined} from '@ant-design/icons'

const items = [
    {label: 'All Orders', key: 'All Orders'},
    {label: 'Unverified', key: 'Unverified'},
    {label: 'Unpaid', key: 'Unpaid'},
    {label: 'Unfulfilled', key: 'Unfulfilled'}
]

export default function OrderCategoryButton(props) {
    const onChangeFilter = (value) => {
        props.onChange(value)
    }

    const groupFilter = (group) => {
        if (group === "All Orders") {
            onChangeFilter(null);
        } else if (group === "Unverified") {
            onChangeFilter({
                paymentFilter: {
                    text: 'payment: ',
                    value: "none",
                    display_value: "Unverified",
                }
            });
        } else if (group === "Unpaid") {
            onChangeFilter({
                paymentFilter: {
                    text: 'payment: ',
                    value: "none,order-verified,unpaid",
                    display_value: "None, Order Verified, Unpaid"
                }
            })
        } else if (group === "Unfulfilled") {
            onChangeFilter({
                fulfillmentFilter: {
                    text: 'fulfillment: ',
                    value: "none",
                    display_value: "Unfulfilled"
                }
            });
        }
    }
    const onClick = ({key}) => {
        groupFilter(key)
        setButtonDisplay(key);
    }

    const [buttonDisplay, setButtonDisplay] = useState('All Orders');

    return (
        <Dropdown menu={{items, onClick}}>
            <Button size='medium' style={{backgroundColor: '#D3D3D3'}}>
                {buttonDisplay}
                <DownOutlined/>
            </Button>
        </Dropdown>
    )
}